import React from 'react';
import PropTypes from 'prop-types';
import Map from './Components/Map/SenateWidget';
import { Wrapper, Left, Middle } from './Symbols/WidgetLayout';
import { centrumBackground, wrapperCentrum, flexContainer, center } from './Symbols/WidgetLayoutCentrum';
import WidgetSuggest from './Components/WidgetSuggest';
import { Link, Title } from './Components/WidgetMunicipalCount/styles';

export default class App extends React.PureComponent {

	onSelect = (event, { suggestion: { id } = {} }) => {
		window.location.href = this.props.linkToMunicipal +'#/obec/'+ id;
	};

	render() {
		return <Wrapper className={wrapperCentrum}>
			<Left className={centrumBackground}>
				<Map className={center} link={this.props.linkToSenate} />
			</Left>
			<Middle>
				<div className={flexContainer}>
					<Title>
						Komunální volby
					</Title>
					<Link>
						<a href={this.props.linkToMunicipal}>Souhrnné výsledky</a>
					</Link>
				</div>
				<WidgetSuggest
					rootUrl={`${this.props.rootUrl}municipal/${this.props.year}/`}
					onSelect={this.onSelect}
				/>
			</Middle>
		</Wrapper>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	linkToSenate: PropTypes.string.isRequired,
	linkToMunicipal: PropTypes.string.isRequired
};

App.defaultProps = {
	linkToSenate: '#',
	linkToMunicipal: '#'
};
